import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { UploadModal } from "./UploadModal";
import "./Navbar.css";

const Navbar = () => {
  const [isResponsive, setIsResponsive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  const toggleNavbar = () => {
    setIsResponsive(!isResponsive);
  };

  return (
    <header className={`navbar ${isResponsive ? "responsive" : ""}`}>
      {/* Site title - always visible on left */}
      <div className="site-title">
        <Link to="/">BERLIN WALL ARCHIVE</Link>
      </div>

      {/* Centered navigation pill with glassmorphism */}
      <div className="nav-center-pill">
        <div className="nav-links">
          <Link to="/" className={location.pathname === "/" ? "active" : ""}>Home</Link>
          <Link to="/segments" className={location.pathname === "/segments" || location.pathname.startsWith("/segments") ? "active" : ""}>Segments</Link>
          <Link to="/globe" className={location.pathname === "/globe" || location.pathname === "/Globe" ? "active" : ""}>Globe</Link>
        </div>
      </div>

      {/* Mobile menu icon */}
      <div className="menu-icon-wrap" onClick={toggleNavbar}>
        {isResponsive ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x"
            style={{ color: "white" }}
          >
            <line x1="18" x2="6" y1="6" y2="18" />
            <line x1="6" x2="18" y1="6" y2="18" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-menu"
            style={{ color: "white" }}
          >
            <line x1="4" x2="20" y1="12" y2="12" />
            <line x1="4" x2="20" y1="6" y2="6" />
            <line x1="4" x2="20" y1="18" y2="18" />
          </svg>
        )}
      </div>

      {/* Floating mobile navigation overlay */}
      {isResponsive && (
        <div className="mobile-nav-overlay">
          <div className="mobile-nav-content" onClick={(e) => e.stopPropagation()}>
            {/* Header row with logo and close button */}
            <div className="mobile-nav-header">
              <Link to="/" onClick={toggleNavbar} className="mobile-nav-logo">
                BERLIN WALL ARCHIVE
              </Link>
              <div className="mobile-nav-close" onClick={toggleNavbar}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ color: "white" }}
                >
                  <line x1="18" x2="6" y1="6" y2="18" />
                  <line x1="6" x2="18" y1="6" y2="18" />
                </svg>
              </div>
            </div>

            {/* Main nav links */}
            <div className="mobile-nav-links">
              <Link to="/" onClick={toggleNavbar} className="mobile-nav-link">Home</Link>
              <Link to="/segments" onClick={toggleNavbar} className="mobile-nav-link">Segments</Link>
              <Link to="/globe" onClick={toggleNavbar} className="mobile-nav-link">Globe</Link>
            </div>

            {/* Secondary links */}
            <div className="mobile-nav-secondary">
              <span
                onClick={() => {
                  setShowModal(true);
                  toggleNavbar();
                }}
                className="mobile-nav-secondary-link"
              >
                Upload a Segment
              </span>
              <a
                href="https://markveksler.cargo.site/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={toggleNavbar}
                className="mobile-nav-secondary-link"
              >
                Other Work
              </a>
            </div>
          </div>
        </div>
      )}

      <UploadModal show={showModal} onHide={() => setShowModal(false)} />
    </header>
  );
};

export default Navbar;
